// @ts-nocheck
import { useState } from "react";
import {
  createColumnHelper,
  useReactTable,
  flexRender,
  getCoreRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  getFilteredRowModel,
} from "@tanstack/react-table";
import PropTypes from "prop-types";
import SkipPreviousIcon from '@mui/icons-material/SkipPrevious';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import SkipNextIcon from '@mui/icons-material/SkipNext';
const columnHelper = createColumnHelper();

const Table = ({ columns, data, pageIndex, pageSize, totalRows, onPageChange }) => {
  const [sorting, setSorting] = useState([]);
  const [filtering, setFiltering] = useState("");
  console.log(totalRows, pageSize, 'totalRows / pageSize');

  const totalPages = Math.ceil((totalRows) / pageSize);

  const table = useReactTable({
    data: data || [],
    columns,
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    state: {
      sorting,
      globalFilter: filtering,
    },
    onSortingChange: setSorting,
    onGlobalFilterChange: setFiltering,
  });

  return (
    <div className="table-container">
      <table className="w3-table-all">
        <thead>
          {table.getHeaderGroups().map((headerGroup) => (
            <tr key={headerGroup.id}>
              {headerGroup.headers.map((header) => (
                <th
                  key={header.id}
                  onClick={header.column.getToggleSortingHandler()}
                  style={{ padding: "0 15px" }}
                >
                  {header.isPlaceholder ? null : (
                    <div>
                      {flexRender(header.column.columnDef.header, header.getContext())}
                      {header.column.getIsSorted() ? (
                        header.column.getIsSorted() === "asc" ? " 🔼" : " 🔽"
                      ) : null}
                    </div>
                  )}
                </th>
              ))}
            </tr>
          ))}
        </thead>

        <tbody>
          {table.getRowModel().rows.map((row) => (
            <tr key={row.id}>
              {row.getVisibleCells().map((cell) => (
                <td key={cell.id} style={{ paddingLeft: "15px" }}>
                  {flexRender(cell.column.columnDef.cell, cell.getContext())}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>

      {/* Pagination Controls */}
      <div className="pagination" >
        <button
          disabled={pageIndex === 1}
          onClick={() => onPageChange(1)}
        >
          <SkipPreviousIcon />
        </button>
        <button
          disabled={pageIndex === 1}
          onClick={() => onPageChange(pageIndex - 1)}
        >
          <KeyboardArrowLeftIcon />
        </button>
        <span>
          Page <strong>{pageIndex}</strong> of <strong>{totalPages}</strong>
        </span>
        <button
          disabled={pageIndex === totalPages}
          onClick={() => onPageChange(pageIndex + 1)}
        >
          <KeyboardArrowRightIcon />
        </button>
        <button
          disabled={pageIndex === totalPages}
          onClick={() => onPageChange(totalPages)}
        >
          <SkipNextIcon />
        </button>
      </div>
    </div>
  );
};

Table.propTypes = {
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      header: PropTypes.string.isRequired,
      accessorKey: PropTypes.string.isRequired | undefined,
      align: PropTypes.oneOf(["left", "center", "right"]),
    })
  ).isRequired,
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  pageIndex: PropTypes.number.isRequired,
  pageSize: PropTypes.number.isRequired,
  totalRows: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
};

export default Table;
